Object.defineProperty(exports,"__esModule",{value:true});exports.selectionContainerMixin=undefined;var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryCore=require("victory-core");
var _selectionHelpers=require("./selection-helpers");var _selectionHelpers2=_interopRequireDefault(_selectionHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}

var selectionContainerMixin=exports.selectionContainerMixin=function selectionContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictorySelectionContainer,_base);function VictorySelectionContainer(){_classCallCheck(this,VictorySelectionContainer);return _possibleConstructorReturn(this,(VictorySelectionContainer.__proto__||Object.getPrototypeOf(VictorySelectionContainer)).apply(this,arguments));}_createClass(VictorySelectionContainer,[{key:"getRect",value:function getRect(








































props){var
x1=props.x1,x2=props.x2,y1=props.y1,y2=props.y2,selectionStyle=props.selectionStyle,selectionComponent=props.selectionComponent;
var width=Math.abs(x2-x1)||1;
var height=Math.abs(y2-y1)||1;
var x=Math.min(x1,x2);
var y=Math.min(y1,y2);
return y2&&x2&&x1&&y1?
_react2.default.cloneElement(selectionComponent,{x:x,y:y,width:width,height:height,style:selectionStyle}):null;
}},{key:"getChildren",value:function getChildren(


props){
var children=_react2.default.Children.toArray(props.children);
return[].concat(_toConsumableArray(children),[this.getRect(props)]).map(function(component,i){
return component?_react2.default.cloneElement(component,{key:i}):null;
});
}}]);return VictorySelectionContainer;}(base),_class.displayName="VictorySelectionContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{selectionStyle:_react2.default.PropTypes.object,onSelection:_react2.default.PropTypes.func,onSelectionCleared:_react2.default.PropTypes.func,dimension:_react2.default.PropTypes.oneOf(["x","y"]),standalone:_react2.default.PropTypes.bool,selectionComponent:_react2.default.PropTypes.element}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{selectionStyle:{stroke:"transparent",fill:"black",fillOpacity:0.1},selectionComponent:_react2.default.createElement("rect",null)}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){return _selectionHelpers2.default.onMouseDown(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps){var mutations=_selectionHelpers2.default.onMouseMove(evt,targetProps);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}},onMouseUp:function onMouseUp(evt,targetProps){return _selectionHelpers2.default.onMouseUp(evt,targetProps);}}}],_temp;};exports.default=


selectionContainerMixin(_victoryCore.VictoryContainer);


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/victory-selection-container.js
// module id = 677
// module chunks = 0